<!--
 * @Date: 2020-08-26 16:46:17
 * @Author: MX
 * @LastEditTime: 2024-02-26 17:20:09
 * @Description: 忘记密码
-->
<template>
  <div class="forgetPassword main-wrap">
    <video class="video-box" style="" @contextmenu.prevent id="bannerVideo" src="./login.mp4" disablePictureInPicture="true" controlslist="nodownload nofullscreen noremoteplayback" autoplay loop muted></video>
    <div class="forgetPassword-title">
      登录/重置密码
    </div>
    <div class="forgetPassword-box">
      <div class="title">
        重置密码
      </div>
      <div class="form">
        <el-form
          ref="forgetPasswordForm"
          :model="forgetPasswordForm"
          :rules="rules"
          id="forgetPassword-form"
          autocomplete="off"
          class="login-form"
        >

          <el-form-item class="phoneFormItem" prop="phone">
            <el-input
              placeholder="请输入手机号"
              maxlength="11"
              v-model="forgetPasswordForm.phone"
            >
              <i slot="prefix" class="iconfont icondengluzhuce_shouji" :class="forgetPasswordForm.phone && 'red_color'"></i>
            </el-input>
            <button
              class="sendcodeBtn commonBtn"
              @click.prevent="checkPhone"
              :disabled="isSendCode"
            >
              <span v-if="!isSendCode">发送</span>
              <span v-else>{{ time }}秒</span>
            </button>
          </el-form-item>
          <el-form-item prop="captcha">
            <el-input
              placeholder="请输入验证码"
              maxlength="10"
              autocomplete="off"
              v-model="forgetPasswordForm.captcha"
            >
              <i slot="prefix" class="iconfont icondengluzhuce_yanzhengma"  :class="forgetPasswordForm.captcha && 'red_color'"></i>
            </el-input>
          </el-form-item>
          <!-- 防止浏览器的自动记录密码 账号自动输入到验证码处 -->
          <input type="text" style="position: absolute;left: -10000px;">
          <el-form-item prop="password">
            <el-input
              placeholder="请输入新密码"
              maxlength="18"
              name="password"
              autocomplete="new-password"
              :type="isShowPassword ? 'text' : 'password'"
              v-model="forgetPasswordForm.password"
            >
              <i slot="prefix" class="iconfont icondengluzhuce_mima"  :class="forgetPasswordForm.password && 'red_color'"></i>
              <i
                slot="suffix"
                class="iconfont pointer"
                :class="[
                  isShowPassword
                    ? 'icondenglu_ico_mimakeshi'
                    : 'icondenglu_ico_mimayincang',
                ]"
                @click="toggleIcon"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="passwordAgain">
            <el-input
              placeholder="请再次输入新密码"
              maxlength="18"
              type="password"
              autocomplete="new-password"
              v-model="forgetPasswordForm.passwordAgain"
            >
              <i slot="prefix" class="iconfont icondengluzhuce_mima"></i>
            </el-input>
          </el-form-item>
          <button class="commonBtn cancelBtn" @click.prevent="cancel">
            取消
          </button>
          <button class="commonBtn submitBtn" @click.prevent="submit">
            提交
          </button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import * as Api from '@/api'
import { RULES, VALIDATION } from '@/constants/rules'
import { RESPONSE_SUCCESS } from '@/constants'
// import '@/assets/js/TCaptcha'
import debounce from 'lodash/debounce'
import { AESUtil } from '@/utils/'
export default {
  name: 'ForgetPassword',
  props: {},
  components: {},
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.forgetPasswordForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      isSendCode: false,
      time: 60,
      codeTimer: null,
      rules: {
        phone: [RULES.phone, RULES.checkPhone],
        captcha: [RULES.phoneCode],
        password: [RULES.password, RULES.passwordNew],
        passwordAgain: [{ validator: validatePass, trigger: 'blur' }],
      },
      forgetPasswordForm: {
        phone: '',
        captcha: '',
        password: '',
        passwordAgain: '',
      },
      isShowPassword: false, //不显示
      captcha:""//腾讯验证码
    }
  },
  mounted(){
    this.initTencentCaptcha()
  },
  methods: {
    toggleIcon() {
      this.isShowPassword = !this.isShowPassword
      console.log(this.isShowPassword)
    },
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      this.captcha = new window.TencentCaptcha('2033367267', this.tencentCaptchaCallback, { forceLang: 'zh-cn' });
      // 显示验证码
      // this.captcha.show()
    },
      // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log('腾讯验证码回调：callback', res);
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr
        }
        //发送验证码
        this.sendCode(customParams)
        return res
      }
      // 验证不成功
      return null
    },
    /**
     * @description 6.校验手机号
     */
    checkPhone:debounce(function() {
      if (!this.forgetPasswordForm.phone) {
        return this.$message.warning('请输入手机号')
      }
      if (!VALIDATION.phoneNumber.value.test(this.forgetPasswordForm.phone)) {
        return this.$message.warning('请输入正确的手机号')
      }
      this.captcha?this.captcha.show():this.$message.warning('网络出错，请刷新后尝试！');
    },500),
    //发送验证码
    sendCode(customParams) {
      let httpParams = {
        phone: this.forgetPasswordForm.phone,
        type: 'reset_pwd',
        ...customParams
      }
      Api.sendMessage(httpParams).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.isSendCode = true
          clearInterval(this.codeTimer)
          this.codeTimer = setInterval(() => {
            this.time--
            if (this.time === 0) {
              this.isSendCode = false
              this.time = 60
            }
          }, 1000)
          this.$message.success('获取手机验证码成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //取消
    cancel() {
      this.$router.push({ path: '/login' })
    },
    /**
     * @description 提交
     */
    submit() {
      this.$refs.forgetPasswordForm.validate((valid) => {

        if (valid) {
          const { phone, captcha, password, passwordAgain} = this.forgetPasswordForm;
          Api.resetPwd({ phone, captcha, password: AESUtil.aesEncrypt(password), passwordAgain: AESUtil.aesEncrypt(passwordAgain)}).then((res) => {
            if (res.code === RESPONSE_SUCCESS) {
              this.$message.success('修改密码成功')
              this.$router.push({ path: '/login' })
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
  destroyed() {
    clearInterval(this.codeTimer)
  },
}
</script>

<style lang="scss" scoped>
.forgetPassword {
  position: relative;
  height: 100vh;
  overflow: hidden;
  .video-box {
    position: absolute;
    width: auto;
    height: 100vh;
    top: 64px;
    left: 0;
  }
  .forgetPassword-title {
    position: absolute;
    font-size: 14px;
    line-height: 14px;
    font-weight: 400;
    color: #4c4d57;
    top: 94px;
    left: 30px;
  }
  .forgetPassword-box {
    width: 520px;
    height: 530px;
    background: rgba(255, 255, 255, 0.5); /* 设置背景颜色为白色，透明度为 0.5 */
    backdrop-filter: blur(10px); /* 模糊半径设为 10 像素 */
    border-radius: 10px;
    box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.05);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .title {
      height: 86px;
      line-height: 86px;
      border-bottom: 1px solid $table-border-color;
      text-align: center;
      font-size: 24px;
      color: #2b2d42;
      font-weight: 600;
    }
    .form {
      padding: 0 100px;
      box-sizing: border-box;
      padding-top: 50px;
      .iconfont {
        font-size: 20px;
         &.red_color {
          color: $theme-color;
        }
      }
    }
    .cancelBtn,
    .submitBtn {
      width: 144px;
      height: 54px;
      background-color: #fff;
      color: #4c4d57;
      margin-top: 8px;
    }
    .submitBtn {
      background-color: $theme-color;
      color: #fff;
      font-size: 18px;
      background-image: linear-gradient(to right, #D31027 0%, #EA384D  51%, #D31027  100%);
      padding: 15px 45px;
      text-align: center;
      text-transform: uppercase;
      transition: 0.5s;
      background-size: 200% auto;
      color: white;
      box-shadow: 0 0 20px #eee;
      border-radius: 2px;
    }
    .submitBtn:hover {
      background-position: right center !important; /* change the direction of the change here */
      color: #fff !important;
      text-decoration: none !important;
    }

    .cancelBtn {
      margin-right: 32px;
      font-size: 18px;
      background-image: linear-gradient(to right, #ffeeee 0%, #FFFFFF 51%, #efabab 100%);
      padding: 15px 45px;
      text-align: center;
      text-transform: uppercase;
      transition: 0.5s;
      background-size: 200% auto;
      color: #c31422;
      box-shadow: 0 0 20px #eee;
      border-radius: 2px;
    }

    .cancelBtn:hover {
      background-position: right center; /* change the direction of the change here */
      color: #c31422;
      text-decoration: none;
    }
    .phoneFormItem {
      position: relative;
      .sendcodeBtn {
        position: absolute;
        width: 102px;
        height: 32px;
        border-radius: 4px;
        font-size: 14px;
        right: 10px;
        top: 9px;
        border: 1px solid #c4c8cc;
      }
    }
  }
}
.forgetPassword::v-deep {
  .el-form-item__content {
    height: 50px;
    line-height: 50px;
    .el-input__inner {
      height: 50px;
      line-height: 50px;
    }
  }
  .el-input:focus-within .iconfont {
    color: $theme-color;
  }
  .el-input__prefix {
    left: 10px;
  }
  .el-input__suffix {
    right: 10px;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 40px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 40px;
  }
}
</style>
